import { createSelector, createSlice } from "@reduxjs/toolkit";
import { apiCallBegan } from "./api";
import { updateTeamLoadingStatus } from "./quotes";

// passwordManagement stands for passwordManagement

const slice = createSlice({
  name: "passwordManagement",
  initialState: {
    email: "",
    currentpassword: "",
    updatedpassword: "",
    tokenStatus: "",
    isLoading: false,
    emailSent: false
  },
  reducers: {
    // action => action handler
    storeEmailId: (passwordManagement, action) => {
      passwordManagement.email = action.payload;
    },

    changePassword: (passwordManagement, action) => {
      passwordManagement.email = action.payload.email;
      passwordManagement.updatedpassword = action.payload.updatedpassword;
    },
    setPassword: (passwordManagement, action) => {
      passwordManagement.email = action.payload.email;
      passwordManagement.currentpassword = action.payload.currentpassword;
    },
    updatePassChangeSuccess: (passwordManagement, action) => {
      passwordManagement.success = action.payload;
      passwordManagement.isLoading = false;
    },
    updateError: (passwordManagement, action) => {
      passwordManagement.error = action.payload;
      passwordManagement.isLoading = false;
    },
    updateTokenStatus: (passwordManagement, action) => {
      passwordManagement.tokenStatus = action.payload;
      passwordManagement.isLoading = false;
    },
    startLoading: (passwordManagement) => {
      passwordManagement.isLoading = true;
      passwordManagement.emailSent = false;
      passwordManagement.error = false;
      passwordManagement.success = null;
    },
    stopLoading: (passwordManagement, action) => {
      passwordManagement.isLoading = false;
      passwordManagement.error = false;
      passwordManagement.emailSent = action.payload;
    },
  },
});

export const {
  storeEmailId,
  changePassword,
  setPassword,
  updateError,
  startLoading,
  stopLoading,
  updateTokenStatus,
  updatePassChangeSuccess,
} = slice.actions;

// action creators and selectors

export const updatePassword = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/users/changepassword",
    method: "post",
    data: data,
    onStart: startLoading.type,
    onSuccess: updatePassChangeSuccess.type,
    onError: updateError.type,
  });
export const sendForgotEmail = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/passwordmanagement/forgot",
    method: "post",
    data: data,
    onStart: startLoading.type,
    onSuccess: stopLoading.type,
    onError: updateError.type,
  });
export const sendSignupEmail = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/passwordmanagement/signup",
    method: "post",
    data: data,
    onError: updateError.type,
  });
export const fetchTokenStatus = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/passwordmanagement/getTokenStatus",
    method: "post",
    data: data,
    onStart: startLoading.type,
    onSuccess: updateTokenStatus.type,
    onError: updateError.type,
  });

// selectors
export const getEmail = createSelector(
  (state) => state.entities.passwordManagement,
  (passwordManagement) => passwordManagement.email
);

export const getPassword = createSelector(
  (state) => state.entities.passwordManagement,
  (passwordManagement) => passwordManagement.currentpassword
);
export const getTokenStatus = createSelector(
  (state) => state.entities.passwordManagement,
  (passwordManagement) => passwordManagement.tokenStatus
);
export const getIsLoading = createSelector(
  (state) => state.entities.passwordManagement,
  (passwordManagement) => passwordManagement.isLoading
);
export const getPasswordErr = createSelector(
  (state) => state.entities.passwordManagement,
  (passwordManagement) => passwordManagement.error
)
export const getPasswordSuccess = createSelector(
  (state) => state.entities.passwordManagement,
  (passwordManagement) => passwordManagement.success
)
export const getPasswordEmlSent = createSelector(
  (state) => state.entities.passwordManagement,
  (passwordManagement) => passwordManagement.emailSent
)

export default slice.reducer;
